import { DatePicker, dateToIsoDateOnly, stringToDate } from "@fox/atoms";
import React from "react";
import { CustomFieldEditProps } from "../contracts";

export const DateCustomField: React.FC<CustomFieldEditProps> = ({ customField, onChange }) => {
	return (
		<DatePicker
			label={customField.displayName}
			onChange={(value) => onChange(customField.customFieldId, dateToIsoDateOnly(value))}
			value={stringToDate(customField.value?.toString())}
			includeTime={false}
		/>
	);
};
